/**
 * @fileoverview added by tsickle
 * Generated from: components/loader/formio.loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Component } from '@angular/core';
import { FormioLoader } from './formio.loader';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from './formio.loader';
import * as ɵngcc2 from '@angular/common';

function FormioLoaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelement(1, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} }
var FormioLoaderComponent = /** @class */ (function () {
    function FormioLoaderComponent(loader) {
        this.loader = loader;
    }
    /** @nocollapse */
    FormioLoaderComponent.ctorParameters = function () { return [
        { type: FormioLoader }
    ]; };
FormioLoaderComponent.ɵfac = function FormioLoaderComponent_Factory(t) { return new (t || FormioLoaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormioLoader)); };
FormioLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormioLoaderComponent, selectors: [["formio-loader"]], decls: 2, vars: 3, consts: [["class", "formio-loader-wrapper", 4, "ngIf"], [1, "formio-loader-wrapper"], [1, "formio-loader"]], template: function FormioLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormioLoaderComponent_div_0_Template, 2, 0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.loader.loading$));
    } }, directives: [ɵngcc2.NgIf], pipes: [ɵngcc2.AsyncPipe], styles: [".formio-loader-wrapper[_ngcontent-%COMP%] { position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; z-index: 1000; } .formio-loader[_ngcontent-%COMP%] { position: absolute; left: 50%; top: 50%; margin-left: -30px; margin-top: -30px; z-index: 10000; display: inline-block; border: 6px solid #f3f3f3; border-top: 6px solid #3498db; border-radius: 50%; width: 60px; height: 60px; animation: spin 2s linear infinite; } @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormioLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'formio-loader',
                styles: [".formio-loader-wrapper { position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; z-index: 1000; } .formio-loader { position: absolute; left: 50%; top: 50%; margin-left: -30px; margin-top: -30px; z-index: 10000; display: inline-block; border: 6px solid #f3f3f3; border-top: 6px solid #3498db; border-radius: 50%; width: 60px; height: 60px; animation: spin 2s linear infinite; } @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } } "],
                template: "<div class=\"formio-loader-wrapper\" *ngIf=\"loader.loading$ | async\"> <div class=\"formio-loader\"></div> </div> "
            }]
    }], function () { return [{ type: ɵngcc1.FormioLoader }]; }, null); })();
    return FormioLoaderComponent;
}());
export { FormioLoaderComponent };
if (false) {
    /** @type {?} */
    FormioLoaderComponent.prototype.loader;
}

